import { render } from "./Loading.vue?vue&type=template&id=33ff4c5a&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=33ff4c5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ff4c5a"],['__file',"src/components/GenericComponents/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33ff4c5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33ff4c5a', __exports__)) {
    api.reload('33ff4c5a', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=33ff4c5a&scoped=true", () => {
    api.rerender('33ff4c5a', render)
  })

}


export default __exports__